<template>
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.8375 5.00002C5.8375 5.18335 5.77084 5.35002 5.63751 5.48335L1.30418 9.65002C1.17084 9.76669 1.00417 9.83335 0.837502 9.83335C0.654168 9.83335 0.487498 9.76668 0.354164 9.63335C0.104164 9.36668 0.10416 8.95002 0.370827 8.68335L4.20416 5.00002L0.370827 1.31668C0.10416 1.06668 0.104164 0.633353 0.354164 0.366687C0.604164 0.10002 1.03751 0.100019 1.30418 0.350019L5.63751 4.51669C5.77084 4.65002 5.8375 4.81669 5.8375 5.00002Z" fill="#29ABE2"/>
</svg>

</template>

<script>
  export default {
    name: 'breadIcon'
  }
</script>
